import { BrandingDisabledIf, useModel, useRoute } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import { WidgetContainer, WidgetView } from 'components/shared';
import { PrimaryButton } from "components/ui";
import React from "react";

import "./styles.css";
import "./mobile.css";


/**
 * @function ManageCardsWidget
 * @return {React.Component}
 * @exported true
 * @description This is the manage cards widget
 */
export default function ManageCardsWidget(props) {
    const navigate = useRoute();
    const { branding } = useModel();
    const { colors , options } = branding;
    const hasBackgroundImage = colors.manage_cards_bg_image_abi22 !== null;
    const cardType = options.manage_card_widget_cards_abi22 === "undefined" ? "Both" : options.manage_card_widget_cards_abi22;
    let message = "View, pay, and manage your credit and debit cards.";
    const widgetContainerClassName = hasBackgroundImage ? { className: "manage-cards-widget with-background-image" } : { className: "manage-cards-widget" };
    
    switch(cardType) {
        case "Credit":
            message = "View, pay, and manage your credit cards.";
            break;
        case "Debit":
            message = "View, pay, and manage your debit cards.";
            break;
    }

    const onManageCardsMobileClick = () => {
        if(Util.inMabi) {
            Util.openABI22StandaloneOverlayInMABI23();
        } else {
            navigate("/ch21");
        }
    }

    return (
        <WidgetContainer { ...widgetContainerClassName }>
            <WidgetView>
                <div className="flex-container flex-horizontal align-center">
                    <p className="set-width"><span>{ message }</span></p>

                    <BrandingDisabledIf id="chw23_courseid_abi22" exp={ value => value !== null && value !== undefined }>
                        <PrimaryButton className="show-on-desktop" text="Manage Cards" onClick={ evt => navigate("/chw23") } dataPoint="manage_cards_button" />
                    </BrandingDisabledIf>

                    <BrandingDisabledIf id="ch21_courseid_abi22" exp={ value => value !== null && value !== undefined }>
                        <PrimaryButton className="show-on-mobile" text="Manage Cards" onClick={ onManageCardsMobileClick }  dataPoint="manage_cards_button" />
                    </BrandingDisabledIf>
                </div>
            </WidgetView>
        </WidgetContainer>
    )
}
